<template>
  <CreateSave
      :maxWidth="500"
      :setTitle="setTitle"
      :setItemForm="setItemForm"
      :createData="createData"
      @onCreate="(response) => $emit('onCreateTicketItem', response)"
      v-bind="$attrs"
  >
    <template
        v-slot:default="{
          errors,
          ItemForm
        }"
    >
      <v-row>
        <v-col
            cols="12"
        >
          <v-textarea
              v-model="ItemForm.message"
              :error-messages="errors.message"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Správa"
              :rows="5"
          />
        </v-col>
      </v-row>
    </template>
  </CreateSave>
</template>

<script>
  import TicketItemTasksAuth from '@/services/ticket-item-tasks-auth'

  import CreateSave from '@/components/_Part/_Modal/_Save/Create'

  export default {
    name: 'CreateTicketItem',
    props: [
      'ticketItemId'
    ],
    emits: [
      'onCreateTicketItem'
    ],
    components: {
      CreateSave
    },
    methods: {
      setTitle() {
        return 'Vytvoriť úlohu'
      },
      setItemForm() {
        return {
          message: null
        }
      },
      createData(ItemForm) {
        return TicketItemTasksAuth
          .createTicketItem({
            ticketItemId: this.ticketItemId,
            data: ItemForm
          })
      }
    }
  }
</script>
